import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
  EventEmitter,
  Output,
  TemplateRef,
  ViewContainerRef,
  SimpleChanges,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RefreshGridService } from '../../../../../shared/services/refresh-grid.service'; // Import the shared service
import { EngagementService } from '../../../../../services/engagement.service';
import { RequestStatusEnum } from '../../../../../enums/requestStatusEnum';
import {
  GridModule,
  CellClickEvent,
  DataBindingDirective,
} from '@progress/kendo-angular-grid';
import { KENDO_TOOLTIPS, TooltipDirective } from '@progress/kendo-angular-tooltip';
import { Border, ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import {
  KENDO_LAYOUT,
  LayoutModule,
  SelectEvent,
} from '@progress/kendo-angular-layout';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import {
  KENDO_ICONS,
  IconsModule,
  SVGIcon,
} from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS, ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { IntlModule } from '@progress/kendo-angular-intl';
import { PopupService, PopupRef } from '@progress/kendo-angular-popup'
import {
  starIcon,
  checkCircleIcon,
  envelopIcon,
  plusIcon,
  eyeIcon,
  minusIcon,
  starOutlineIcon,
  cancelCircleIcon,
  brightnessContrastIcon,
  searchIcon,
  playIcon,
} from '@progress/kendo-svg-icons';
import { process } from '@progress/kendo-data-query';


import { Input, ElementRef } from '@angular/core';
import { PopupModule, Align, AnimationDirection, AnimationType, PopupAnimation } from '@progress/kendo-angular-popup';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ShownotificationService } from '../../../../../services/shownotification.service';
import { EngagementrequestService } from '../../../../../services/engagementrequest.service';
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-request-engagement-activity-panel',
  standalone: true,
  templateUrl: './request-engagement-activity-panel.component.html',
  styleUrl: './request-engagement-activity-panel.component.scss',
  imports: [
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_TOOLTIPS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_INDICATORS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    FormsModule,
    ReactiveFormsModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    NgxSpinnerModule
],
})
export class RequestEngagementActivityPanelComponent {
  @Input() openRequestEngagementPopup!: boolean;
  // @Input() engagementRequestForRequest!: any;
  @Input() public engagementDetail: any;
  @Input() public selectedRequestId: any;
  @Input() anchor!: any;
  @Input() requestStatus!: string;
  @Input() isApprovalUser: boolean = false;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() requestEngagementButtonEvent = new EventEmitter<void>();
  public userProfile: any;

  isEngagementApproveFlag = false;
  message: string = ""
  public isDisplayloader: boolean = false;

  @ViewChild('popupContent') popupContent!: TemplateRef<any>;
  //@ViewChild('popupContent') popupContent!:ViewContainerRef;

  // @ViewChild('popupContent', { static: true }) popupContent!: TemplateRef<any>;

  public requestEngagementRequestForm!: FormGroup;
  public selectedEngagementDetail: any;
  public selectedEngagementNumber: string = "";
  public searchedEngagementDetails: any[] = [];
  public RequestStatusEnum = RequestStatusEnum;

  private popupRef: PopupRef | undefined;

  public searchIcon: SVGIcon = searchIcon;
  public playIcon: SVGIcon = playIcon;

  //public form!: FormGroup;
  public enabled = true;
  public duration = 200;
  public type: AnimationType = "slide";
  public direction: AnimationDirection = "left";
  public margin = { horizontal: -30, vertical: -75 };

  public anchorAlign: Align = { horizontal: "right", vertical: "top" };
  public popupAlign: Align = { horizontal: "right", vertical: "top" };

  public get animate(): boolean | PopupAnimation {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }
    return false;
  }

  public isSearchSelected: boolean = true;
  public searchText: string = "";

  private readonly popupService = inject(PopupService);
  private readonly engagementService = inject(EngagementService);
  private readonly engagementrequestService = inject(EngagementrequestService);
  private readonly router = inject(Router);
  private readonly fb = inject(FormBuilder);
  private readonly shownotificationService = inject(ShownotificationService);
  private readonly refreshGridService = inject(RefreshGridService);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private spinner = inject(NgxSpinnerService);

  ngOnChanges(changes: SimpleChanges) {
    this.spinner.show();
    if (changes['engagementDetail']) {
      this.message="";
      if (this.requestStatus === RequestStatusEnum.Pending && !this.isApprovalUser) {
        this.message = 'Request is Pending';
      } else if (this.requestStatus === RequestStatusEnum.Approved && this.isApprovalUser) {
        this.message = 'Already Approved';
      } else if (this.requestStatus === RequestStatusEnum.Rejected) {
        this.message = 'Already Rejected';
      } else if (this.requestStatus === RequestStatusEnum.Completed) {
        this.message = 'Already Completed';
      }

      if (this.engagementDetail) {
        this.setEngagementRequestRequestFormValues();
        this.engagementDetail.activityStream = [{ description: this.engagementDetail.requestUserComment, date: new Date(this.engagementDetail.requestedOn), title: this.engagementDetail.requestUserDisplayName, subtitle: 'Requester' }];
        if (!(this.isApprovalUser && (this.requestStatus === RequestStatusEnum.Pending))) {
          this.engagementDetail.activityStream.push({ description: this.engagementDetail.approvalUserComment, date: new Date(this.engagementDetail.approvedUserActionedOn), title: this.engagementDetail.approvalUserDisplayName, subtitle: 'Approver' });
          if (this.requestStatus === RequestStatusEnum.Completed) {
            this.engagementDetail.activityStream.push({ description: this.engagementDetail.supportUserComment, date: new Date(this.engagementDetail.completedOn), title: this.engagementDetail.supportUserDisplayName, subtitle: 'Support User' });
          }
        }
      } else {
        this.isDisplayloader = true;
        this.spinner.show();
      }
    }
  }

  ngOnInit(): void {
    this.userProfile = JSON.parse(localStorage.getItem('userProfile') ?? "");
    this.createEngagementRequestRequestForm();
    this.isDisplayloader = true;
    this.spinner.show();
    if (this.engagementDetail) {
      this.setEngagementRequestRequestFormValues();
    }
  }

  handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  public open(): void {
    this.openRequestEngagementPopup = true;
    this.resetEngagementRequestRequestForm();

  }

  public close(): void {
    this.openRequestEngagementPopup = false;
    this.closeEvent.emit();
    this.resetEngagementRequestRequestForm();
    this.isSearchSelected = true;
    this.searchText = "";
  }

  public onFilter(value: Event): void {
    const inputValue = value;
  }

  public createEngagementRequestRequestForm(): void {
    this.requestEngagementRequestForm = this.fb.group({
      ClientCode: [null, Validators.required],
      ClientName: [null, Validators.required],
      EngagementNumber: [null, Validators.required],
      EngagementName: [null, Validators.required],
      EngagementType: [null, Validators.required],
      EngagementCreatedDate: [null, Validators.required],
      EngagementClosedDate: [null],
      EngagementStatus: [null, Validators.required],
      ProfitCenterCode: [null],
      ProfitCenterDescription: [null, Validators.required],
      Function: [null],
      FunctionDescription: [null],
      // Area { get; set; }
      ServiceGroup: [null],
      ServiceGroupDescription: [null],
      ServiceLine: [null],
      ServiceLineDescription: [null],
      ServiceNetworkCode: [null],
      ServiceNetworkDescription: [null],
      LineOfBusiness: [null, Validators.required],
      EngagementPartnerName: [null],
      EngagementPartnerEmailAddress: [null],
      EngagementManagerName: [null],
      EngagementManagerEmailAddress: [null],
      MatchedColumns: [null],
      ApprovalUserId: [null],
      ApprovalUserEmail: [null],
      ApprovalUserComment: [null],
      SupportUserId: [null],
      SupportUserEmail: [null],
      SupportUserComment: [null],
    });
  }

  public resetEngagementRequestRequestForm(): void {
    //  if (this.form) {
    //    this.form.resetForm();
    //  }
  }

  public setEngagementRequestRequestFormValues() {
    if (this.engagementDetail && this.requestEngagementRequestForm) {
      this.requestEngagementRequestForm.setValue({
        ClientCode: this.engagementDetail.clientCode,
        ClientName: this.engagementDetail.clientName,
        EngagementNumber: this.engagementDetail.engagementNumber,
        EngagementName: this.engagementDetail.engagementName,
        EngagementType: this.engagementDetail.engagementType,
        EngagementCreatedDate: this.engagementDetail.engagementCreatedDate,
        EngagementClosedDate: this.engagementDetail.engagementClosedDate,
        EngagementStatus: this.engagementDetail.engagementStatus,
        ProfitCenterCode: this.engagementDetail.profitCenterCode,
        ProfitCenterDescription: this.engagementDetail.profitCenterDescription,
        Function: this.engagementDetail.function,
        FunctionDescription: this.engagementDetail.functionDescription,
        // Area { get; set; }
        ServiceGroup: this.engagementDetail.serviceGroup,
        ServiceGroupDescription: this.engagementDetail.serviceGroupDescription,
        ServiceLine: this.engagementDetail.serviceLine,
        ServiceLineDescription: this.engagementDetail.serviceLineDescription,
        ServiceNetworkCode: this.engagementDetail.serviceNetworkCode,
        ServiceNetworkDescription: this.engagementDetail.serviceNetworkDescription,
        LineOfBusiness: this.engagementDetail.lineOfBusiness,
        EngagementPartnerName: this.engagementDetail.engagementPartnerName,
        EngagementPartnerEmailAddress: this.engagementDetail.engagementPartnerEmailAddress,
        EngagementManagerName: this.engagementDetail.engagementManagerName,
        EngagementManagerEmailAddress: this.engagementDetail.engagementManagerEmailAddress,
        MatchedColumns: this.engagementDetail.matchedColumns,
        ApprovalUserId: this.isApprovalUser ? this.userProfile.id : null,
        ApprovalUserEmail: this.isApprovalUser ? this.userProfile.email : this.engagementDetail.approvalUserEmail,
        ApprovalUserComment: this.isApprovalUser ? '' : this.engagementDetail.approvalUserComment,
        SupportUserId: !this.isApprovalUser ? this.userProfile.id : null,
        SupportUserEmail: !this.isApprovalUser ? this.userProfile.email : null,
        SupportUserComment: ''
      });
      this.isDisplayloader = false;
      this.spinner.hide();
    }
  }

  public approveEngagementRequest(): void {
    //this.setEngagementAddDetailsFormValues();
    if (this.requestEngagementRequestForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      this.isEngagementApproveFlag = true;
      this.engagementrequestService.approveOrDenyEngagementRequestDetails(this.requestEngagementRequestForm.value, this.selectedRequestId, this.isEngagementApproveFlag).subscribe({
        next: (_) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.shownotificationService.showNotification('successEnagagemetState');
          //this.requestEngagementButtonEvent.emit();
          this.close();
          this.refreshGridService.refreshRequestGrid.next(true);
        },
        error: (x) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.close();
        }
      });


    }

  }

  public denyEngagementRequest(): void {
    //this.setEngagementAddDetailsFormValues();
    if (this.requestEngagementRequestForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      this.isEngagementApproveFlag = false;
      this.engagementrequestService.approveOrDenyEngagementRequestDetails(this.requestEngagementRequestForm.value, this.selectedRequestId, this.isEngagementApproveFlag).subscribe({
        next: (_) => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.shownotificationService.showNotification('denyEnagagemetState');
          //this.requestEngagementButtonEvent.emit();
          this.close();
          this.refreshGridService.refreshRequestGrid.next(true);
        },
        error: () => {
          this.isDisplayloader = false;
          this.spinner.hide();
          this.close();

        }
      });

    }

  }

  public addEngagementRequest(): void {
    if (this.requestEngagementRequestForm.valid) {
      this.isDisplayloader = true;
      this.spinner.show();
      this.engagementrequestService.AddEngagementDetails(this.requestEngagementRequestForm.value, this.selectedRequestId).subscribe(
        {
          next: () => {
            this.shownotificationService.showNotification('successAddEnagagemetState');
            this.isDisplayloader = false;
            this.spinner.hide();
            this.refreshGridService.refreshRequestGrid.next(true);
            this.close();
          },
          error: (error) => {
            var errorResult = JSON.parse(error.error);
            if (errorResult.StatusCode == "500") {
              this.shownotificationService.showNotification(errorResult.StatusCode, errorResult.StatusCode + ":Internal Server Error")
            }
            else if (errorResult.StatusCode == "503") {
              this.shownotificationService.showNotification(errorResult.StatusCode, errorResult.StatusCode + ":Service Unavailable")
            }
            else {
              this.shownotificationService.showNotification("engagementRequestAlreadyExistError", errorResult.ErrorMessage);
            }
            this.isDisplayloader = false;
            this.spinner.hide();
            this.close();
          }
        });
    }

  }

  public cancelEngagementRequest(): void {
    this.close();

  }
}
